import React, { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { MdClose } from "react-icons/md";
import { RiEditFill } from "react-icons/ri";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

const StoreDetailsEdit = ({ profiledate, editicon, sellerId }) => {
  const { register, handleSubmit, setValue, watch } = useForm();
  const [categoryInput, setCategoryInput] = useState("");
  const [categories, setCategories] = useState([]);
  const [categorieslist, setCategorieslist] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [save, setSave] = useState(false);

  // Fetch the real category list, same source the create flow uses
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.post(
          `${API_BASE_URL}/store_category/get-store-categories`,
          { filters: {}, page: 1, limit: 10 },
          { headers: { accept: "application/json", "Content-Type": "application/json" } }
        );
        const list = res.data?.result?.storeCategories?.map((cat) => ({
          id: cat.id,
          title: cat.title,
        }));
        setCategorieslist(list || []);
      } catch (error) {
        console.error("Category Fetch Error:", error);
      }
    };
    fetchCategories();
  }, []);

  // Preload existing data into the form whenever edit mode opens
  useEffect(() => {
    if (save && profiledate) {
      setValue("storeName", profiledate.store_name || "");
      setValue("description", profiledate.store_description || "");
      setCategories(profiledate.categories || []);
    }
  }, [save, profiledate, setValue]);

  const onSubmit = (data) => {
    data.categories = categories;
    console.log("Form Submitted:", data);
  };

  const filteredCategories = categorieslist.filter(
    (cat) =>
      cat.title.toLowerCase().includes(categoryInput.toLowerCase()) &&
      !categories.some((selected) => selected.id === cat.id)
  );

  const addCategory = (cat) => {
    if (cat && !categories.some((c) => c.id === cat.id)) {
      setCategories([...categories, cat]);
      setCategoryInput("");
      setShowDropdown(false);
    }
  };

  const removeCategory = (cat) => {
    setCategories(categories.filter((c) => c.id !== cat.id));
  };

  return (
    <div>
      <div className="  p-0  sm:p-5">
        <div className="flex flex-row justify-between border-b-2">
          <p className="text-lg text-[#095228] font-medium">
            Set Up Your Store
          </p>
          {!sellerId &&
            (save === true ? (
              <button
                onClick={() => setSave(false)}
                className="text-xs m-1 bg-green-800 py-1 rounded-xl px-3 font-medium text-white file:"
              >
                Close
              </button>
            ) : (
              <button onClick={() => setSave(true)} className="text-xs">
                <RiEditFill className="text-[18px]" />
              </button>
            ))}
        </div>
        {save === true ? (
          <div>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
              {/* Store Name */}
              <div>
                <label className="font-semibold text-sm">Store Name</label>
                <input
                  type="text"
                  {...register("storeName", { required: true })}
                  placeholder="Enter Store Name"
                  className="w-full border border-gray-300 rounded-md px-4 py-2 mt-1 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-700"
                />
              </div>

              {/* Description */}
              <div>
                <label className="font-semibold text-sm">Description</label>
                <textarea
                  {...register("description")}
                  placeholder="Enter Description"
                  rows={4}
                  maxLength={1000}
                  className="w-full border border-gray-300 rounded-md px-4 py-2 mt-1 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-700"
                />
                <p className="text-xs text-right text-gray-400 mt-1">
                  {watch("description")?.length || 0} / 1000 Characters
                </p>
              </div>

              {/* Categories */}
              <div className="w-full relative">
                <label className="font-semibold text-sm">Categories</label>
                <div className="flex flex-wrap items-center gap-2 mt-2 border border-gray-300 rounded-md px-2 py-2 focus-within:ring-2 focus-within:ring-green-700">
                  {categories.map((cat) => (
                    <span
                      key={cat.id}
                      className="flex items-center gap-1 px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm"
                    >
                      {cat.title}
                      <button
                        type="button"
                        onClick={() => removeCategory(cat)}
                        className="text-red-500 hover:text-red-700"
                      >
                        <MdClose size={14} />
                      </button>
                    </span>
                  ))}
                  <input
                    type="text"
                    placeholder={
                      categories.length === 0 ? "Type a category to search" : ""
                    }
                    value={categoryInput}
                    onChange={(e) => {
                      setCategoryInput(e.target.value);
                      setShowDropdown(true);
                    }}
                    onFocus={() => setShowDropdown(true)}
                    onBlur={() => setTimeout(() => setShowDropdown(false), 100)}
                    className="flex-grow min-w-[120px] border-none focus:outline-none"
                  />
                </div>

                {/* Dropdown */}
                {showDropdown && filteredCategories.length > 0 && (
                  <ul className="absolute bg-white border border-gray-300 rounded-md w-full mt-1 max-h-40 overflow-auto shadow-lg z-10">
                    {filteredCategories.map((cat) => (
                      <li
                        key={cat.id}
                        className="px-4 py-2 cursor-pointer hover:bg-green-100"
                        onMouseDown={() => addCategory(cat)}
                      >
                        {cat.title}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Submit */}
              <button
                type="submit"
                className="mt-4 px-4 py-2 bg-green-700 text-white rounded-md hover:bg-green-800"
              >
                Save
              </button>
            </form>
          </div>
        ) : (
          <div className="">
            <div className="space-y-5 mt-5">
              <div>
                <p className="text-gray-500 font-medium text-[14px]">
                  Store Name
                </p>
                <p className="text-[14px] font-medium">
                  {profiledate?.store_name || "xxxxxxxx"}
                </p>
              </div>

              <div className="mb-4 w-full">
                <p className="text-gray-500 font-medium text-[14px]">
                  Description
                </p>
                <p className="mt-1 border rounded-md p-2 text-gray-500 break-all whitespace-pre-wrap w-full max-w-full">
                  {(
                    profiledate?.store_description ||
                    "No introduction available."
                  ).trim()}
                </p>
              </div>

              <div>
                <p className="text-gray-500 font-medium text-[14px]">
                  Categories
                </p>
                <div className="flex flex-wrap gap-2 mt-2">
                  {profiledate?.categories.map((item) => (
                    <span
                      key={item?.id}
                      className="bg-green-100 text-green-800 text-sm px-3 py-1 rounded-full border border-green-300"
                    >
                      {item?.title}
                    </span>
                  ))}
                </div>
              </div>
              <div className="mt-8 flex sm:flex-row flex-col gap-4 sm:gap-20">
                <div>
                  <p className="text-gray-500 font-medium text-[14px]">
                    Country
                  </p>
                  <p className="text-[14px] font-medium">
                    {profiledate?.country || "xxxxxx"}
                  </p>
                </div>
                <div>
                  <p className="text-gray-500 font-medium text-[14px]">
                    Currency
                  </p>
                  <p className="text-[14px] font-medium">
                    {profiledate?.currency || "xxxxxx"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StoreDetailsEdit;
